// extracted by mini-css-extract-plugin
export default {"password":"LAPS_password__ymqC6"};